import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-find-criteria',
  templateUrl: './find-criteria.component.html',
  styleUrls: ['./find-criteria.component.scss']
})
export class FindCriteriaComponent implements OnInit {

  @Input() title: string;
  @Input() subTitle: string;
  @Input() inputLabel: string;
  @Input() buttonCaption: string;
  @Input() popupImage: string;
  @Input() popupImageAlt: string;
  @Input() popupText: string;
  @Input() type: string;

  @Output() search = new EventEmitter<string>();

  @Input() @Output() criteria: any;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/find-criteria/find-criteria.component.ts